<template>
  <div class="wrap">
    <div style="width: 100%; margin: 20px 0">
      <el-form
        ref="form"
        :model="sizeForm"
        label-width="100px"
        :rules="editFormRules"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="服务类型" prop="feedbackType">
              <el-select v-model="sizeForm.feedbackType" placeholder="全部">
                <el-option label="居家服务" value="1"></el-option>
                <el-option label="机构养老" value="2"></el-option>
                <el-option label="适老化改造" value="3"></el-option>
                <el-option label="家庭床位" value="4"></el-option>
                <el-option label="意见" value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="sizeForm.contactPerson"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model="sizeForm.contactPhone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="反馈意见" prop="content" label-width="100px">
              <el-input
                type="textarea"
                v-model="sizeForm.content"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item size="large">
          <el-button type="primary" @click="onSubmit('sizeForm')"
            >提交反馈</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div style="width: 90%; margin: 0 5%">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="feedbackType" label="反馈类型" width="180">
          <template slot-scope="scope">
            <el-tag
              size="small"
              v-if="scope.row.feedbackType === 1"
              type="danger"
              >居家服务</el-tag
            >
            <el-tag
              size="small"
              v-else-if="scope.row.feedbackType === 2"
              type="danger"
              >机构养老</el-tag
            >
            <el-tag
              size="small"
              v-else-if="scope.row.feedbackType === 3"
              type="danger"
              >适老化改造</el-tag
            >
            <el-tag
              size="small"
              v-else-if="scope.row.feedbackType === 4"
              type="danger"
              >家庭床位</el-tag
            >
            <el-tag
              size="small"
              v-else-if="scope.row.feedbackType === 5"
              type="danger"
              >意见</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="contactPerson" label="联系人" width="180">
        </el-table-column>
        <el-table-column prop="contactPhone" label="联系电话">
        </el-table-column>
        <el-table-column prop="content" label="内容"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "feedback",
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now();
        },
      },
      userInfo: {
        id: "",
        username: "7777",
        avatar: "",
      },
      username: "",
      dialogVisible: false,
      sizeForm: {},
      sizeFormRules: {},
      tableData: [],
      oldManList: [],
      editFormRules: {
        feedbackType: [
          { required: true, message: "请选择服务类型", trigger: "blur" },
        ],
        contactPerson: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.init();
  },
  methods: {
    onSubmit() {
      this.sizeForm.userId = this.userInfo.id;
      this.sizeForm.username = this.userInfo.username;
      this.sizeForm.createId = this.userInfo.id;
      this.sizeForm.createName = this.userInfo.username;
      this.$axios.post("/gw/complaint/save", this.sizeForm).then((res) => {
        if (res.status == 200) {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.init();
            },
          });
        } else {
          this.$message({
            message: "反馈失败",
            type: "warning",
          });
        }
      });
    },
    init() {
      this.$axios
        .get("/gw/complaint/home/list", {
          params: {
            // customerName: this.searchForm.name,
            // customerName: this.current,
            // phone: this.size,
            // state:''
          },
        })
        .then((res) => {
          this.tableData = res.data.data.records;
        });
    },
  },
};
</script>

<style scoped>
.wrap {
  height: 7.1875rem /* 115px -> 7.1875rem */;
  width: 100%;
}

.header-left {
  float: left;
  width: 18.75rem /* 300px -> 18.75rem */;
  height: 100%;
  margin-left: 15.625rem /* 250px -> 15.625rem */;
  color: #000;
}

.address {
  float: left;
}

.header-right-line {
  float: right;
  color: #000;
  width: 9.375rem /* 150px -> 9.375rem */;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.header-right {
  float: right;
  color: #000;
  width: 10rem /* 160px -> 10rem */;
  margin-right: 13.75rem /* 220px -> 13.75rem */;
}

.login {
  float: left;
  width: 5rem /* 80px -> 5rem */;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  height: 7.1875rem /* 115px -> 7.1875rem */;
}

.login:hover {
  height: 7rem /* 112px -> 7rem */;
  border-bottom: 3px solid #e6a23c;
}

.registered {
  float: left;
  width: 5rem /* 80px -> 5rem */;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  height: 7.1875rem /* 115px -> 7.1875rem */;
}

.registered:hover {
  height: 7rem /* 112px -> 7rem */;
  border-bottom: 3px solid #f77f00;
}

.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
</style>
